export default "__VITE_ASSET__BaZaI8nO__"